const ChannelTypes = {
  SITE: 'site',
  MOBILE_PATROL: 'mobile_patrol',
  BRANCH: 'branch',
};

const MessageTypes = {
  USER: 'user',
  ACTIVITY: 'activity',
};

// How much of the channel list is loaded: the header only needs channels with unread messages;
// the Chat page needs all of them.
const ChannelsScope = {
  UNREAD: 'unread',
  ALL: 'all',
};

const PaginationDirection = {
  INITIAL: 'initial',
  BEFORE: 'before',
  AFTER: 'after',
};

export {
  ChannelTypes,
  MessageTypes,
  ChannelsScope,
  PaginationDirection,
};
